import { LoadingManager, TextureLoader } from 'three';

export class Loading {
  constructor() {
    this.loadingManager = new LoadingManager();
    this.textureLoader = new TextureLoader(this.loadingManager);

    this.progressBar = document.getElementById('progress-bar');
    this.progressBarContainer = document.querySelector('.progress-bar-container');

    this.loadingManager.onProgress = (url, loaded, total) => {
      this.progressBar.value = (loaded / total) * 100;
    };
    this.loadingManager.onLoad = () => {
      this.progressBarContainer.classList.add('fade-out');
      this.progressBarContainer.addEventListener(
        'transitionend',
        () => {
          this.progressBarContainer.remove();
        },
        { once: true }
      );
    };
  }
}

export const loading = new Loading();

